import { useState } from "react";
import { Button, Input, Label } from "@bloom/ui";
import { useLocale } from "../locale/locale-context.tsx";
import { AuthShell } from "./login.tsx";

export function ForgotPasswordPage() {
  const { t } = useLocale();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await fetch("/api/auth/forget-password", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ email, redirectTo: `${window.location.origin}/reset-password` }),
    });
    setSent(true);
  };

  return (
    <AuthShell heading={t("auth.forgot_password")}>
      {sent ? (
        <p className="text-sm text-[var(--brand-muted)]">
          {t("auth.verify_email_sent", { email })}
        </p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1">
            <Label htmlFor="email">{t("auth.email")}</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <Button type="submit" className="w-full">
            {t("auth.continue")}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
